// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AltS","fullView":"styles_fullView__37kHj"};